import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { MaintenanceFormPage } from "@/pages/dashboard/maintenance/form";

export const Route = createFileRoute("/_main/dashboard/maintenance/new")({
  component: () => (
    <RequirePermission action="maintenance.write">
      <MaintenanceFormPage />
    </RequirePermission>
  ),
});
